import HomeworkLayout from '../layouts/HomeworkLayout.vue';

const BookWidgetView = () => import('../views/Homeworks/BookWidgetView.vue');

export default {
  path: '/dziecko/:kidId/prace-domowe/wykonaj',
  name: 'Homeworks',
  component: HomeworkLayout,
  redirect: { name: 'Main.Homeworks' },
  meta: {
    background: 'blue-light-main',
  },
  children: [
    {
      path: 'bookwidgets/:homeworkId',
      name: 'Homeworks.BookWidgets',
      component: BookWidgetView,
      meta: {
        unauthorized: true,
      },
    },
  ],
};
